<template>
  <component :is="componentTag" />
</template>
<script>
import webIndustryInformation from './web';
import mobileIndustryInformation from './mobile';
export default {
  components: {
    webIndustryInformation,
    mobileIndustryInformation
  },
  data() {
    return {
       isMobile: false,
       componentTag: ''
    };
  },
  created() {
     this.listenObserverWidth(750);
  },
  methods: {
    // 监听可视窗口宽度
    listenObserverWidth(mobileWidth) {
       const resizeObserver = new ResizeObserver(entries => {
          for(let entry of entries) {
             if(entry.contentRect.width <= mobileWidth) {
                this.componentTag = 'mobileIndustryInformation';
             } else {
                this.componentTag = 'webIndustryInformation';
             }
          }
       });
       resizeObserver.observe(document.body);
    }
  },
};
</script>
